// Form handlers and input utilities
window.setupFormHandlers = function setupFormHandlers(switchToTabFunction) {
    // Attach form submission prevention to all edit forms
    const editForms = document.querySelectorAll('.edit-form');
    editForms.forEach(form => {
        // Check if form already has a submit listener to avoid duplicates
        form.addEventListener('submit', function(e) {
            e.preventDefault();
            
            // Check if this is the RSVP form and handle specially
            const isRSVPForm = this.closest('[data-model="rsvp-tab"]');
            const isScheduleForm = this.closest('[data-model="schedule-form-tab"]');
            const isGiftRegistryForm = this.closest('[data-model="gift-registry-form-tab"]');
            
            if (isRSVPForm && typeof window.saveRSVPFormData === 'function') {
                // Save complete RSVP data including custom questions
                window.saveRSVPFormData();
            } else if (isScheduleForm && typeof window.saveScheduleData === 'function') {
                // Save latest schedule items (captures any uncommitted field edits)
                window.saveScheduleData();
            } else if (isGiftRegistryForm && typeof window.saveGiftRegistryData === 'function') {
                // Save latest gift registry items
                window.saveGiftRegistryData();
            } else if (window.formDataStorage) {
                // Regular form data save
                const formData = extractFormDataWithThemeKeys(this);
                window.formDataStorage.saveFormData(formData);
            }
            
            // Use navigateToNextTab if available (supports both tab and model systems)
            if (typeof window.navigateToNextTab === 'function') {
                return window.navigateToNextTab(this);
            } else if (switchToTabFunction) {
                return switchToTabFunction(this);
            }
            return false;
        });
    });

    // Make date and time inputs fully clickable
    function makeInputFullyClickable() {
        // Handle date inputs
        const dateInputs = document.querySelectorAll('input[type="date"]');
        dateInputs.forEach(input => {
            // Make the entire input clickable
            input.addEventListener('click', function() {
                // For desktop browsers, show the picker
                if (!this.showPicker) {
                    this.focus();
                } else {
                    try {
                        this.showPicker();
                    } catch (e) {
                        this.focus();
                    }
                }
            });

            // Also make the parent floating label clickable
            const parentFloating = input.closest('.form-floating');
            if (parentFloating) {
                const label = parentFloating.querySelector('label');
                if (label) {
                    label.addEventListener('click', function() {
                        if (!input.showPicker) {
                            input.focus();
                        } else {
                            try {
                                input.showPicker();
                            } catch (e) {
                                input.focus();
                            }
                        }
                    });
                }
            }
        });

        // Handle time inputs
        const timeInputs = document.querySelectorAll('input[type="time"]');
        timeInputs.forEach(input => {
            // Make the entire input clickable
            input.addEventListener('click', function() {
                // For desktop browsers, show the picker
                if (!this.showPicker) {
                    this.focus();
                } else {
                    try {
                        this.showPicker();
                    } catch (e) {
                        this.focus();
                    }
                }
            });

            // Also make the parent floating label clickable
            const parentFloating = input.closest('.form-floating');
            if (parentFloating) {
                const label = parentFloating.querySelector('label');
                if (label) {
                    label.addEventListener('click', function() {
                        if (!input.showPicker) {
                            input.focus();
                        } else {
                            try {
                                input.showPicker();
                            } catch (e) {
                                input.focus();
                            }
                        }
                    });
                }
            }
        });
    }

    // Initialize clickable inputs
    makeInputFullyClickable();

    // Initialize custom media handlers (edit/delete)
    setupCustomMediaHandlers();
}

function setupCustomMediaHandlers() {
    const getMediaTypeFromInput = (inputElement) => {
        const accept = (inputElement?.getAttribute('accept') || '').toLowerCase();
        return accept.includes('video') ? 'video' : 'image';
    };

    const setMediaSrcByUid = (uid, srcValue) => {
        const sourceValue = srcValue || '';

        const pageElements = Array.from(document.querySelectorAll(`[data-key-uid="${uid}"]`));
        pageElements.forEach((element) => {
            if (element.tagName === 'IMG' || element.tagName === 'VIDEO') {
                element.src = sourceValue;
                if (element.tagName === 'VIDEO' && typeof element.load === 'function') {
                    element.load();
                }
            }
        });

        const themeIframe = document.getElementById('theme-iframe');
        const iframeDoc = themeIframe?.contentDocument || themeIframe?.contentWindow?.document || null;
        if (!iframeDoc) return;

        const iframeElements = Array.from(iframeDoc.querySelectorAll(`[data-key-uid="${uid}"]`));
        iframeElements.forEach((element) => {
            if (element.tagName === 'IMG' || element.tagName === 'VIDEO') {
                element.src = sourceValue;
                if (element.tagName === 'VIDEO' && typeof element.load === 'function') {
                    element.load();
                }
            }
        });
    };

    const editButtons = document.querySelectorAll('.media-edit-button[data-media-id]');
    editButtons.forEach((button) => {
        if (button.dataset.boundEditHandler === 'true') return;
        button.dataset.boundEditHandler = 'true';

        button.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();

            const inputId = button.getAttribute('data-media-id');
            if (!inputId) return;

            // Scope lookup to the button's own container (PPM box or sidebar modal)
            // so templates rendered in both places (e.g. branding-logo / cover-image)
            // don't cross-contaminate each other via duplicate IDs.
            const scope = button.closest('.ppm-content-box, .model-box');
            const inputElement = (scope && scope.querySelector(`.media-file-input[id="${inputId}"]`))
                              || document.querySelector(`.media-file-input[id="${inputId}"]`)
                              || document.getElementById(inputId);
            if (!inputElement) return;

            // previewEl: button is inside .media-preview-card so this is always scoped correctly.
            const previewEl = button.closest('.media-preview-card')?.querySelector('.preview-container')
                           || null;

            // Use the media-library picker if available
            if (typeof window.openMediaPicker === 'function') {
                window.openMediaPicker(inputElement, previewEl);
            } else {
                inputElement.click();
            }
        });
    });

    const deleteButtons = document.querySelectorAll('.media-delete-button[data-media-id]');
    deleteButtons.forEach((button) => {
        if (button.dataset.boundDeleteHandler === 'true') return;
        button.dataset.boundDeleteHandler = 'true';

        button.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();

            const inputId = button.getAttribute('data-media-id');
            // Scope to the button's container to avoid picking up the sidebar/PPM duplicate.
            const delScope = button.closest('.ppm-content-box, .model-box');
            const inputElement = inputId
                ? ((delScope && delScope.querySelector(`.media-file-input[id="${inputId}"]`))
                    || document.querySelector(`.media-file-input[id="${inputId}"]`)
                    || document.getElementById(inputId))
                : null;
            if (!inputElement) return;

            const mediaType = getMediaTypeFromInput(inputElement);
            const previewCard = button.closest('.media-preview-card');
            const previewContainer = previewCard ? previewCard.querySelector('.preview-container') : null;
            const defaultSrc = inputElement.getAttribute('data-media-default') || inputElement.getAttribute('data-default') || '';
            // console.log('Default source for media:', defaultSrc);
            const themeUid = inputElement.getAttribute('data-theme-uid');

            inputElement.value = '';
            inputElement.setAttribute('data-file-action', 'delete');
            inputElement._selectedFiles = null;  // Clear any pending file so delete wins
            button.setAttribute('data-show-btn', 'false');

            // Pause any playing video before replacing the preview
            if (previewContainer) {
                const oldVideo = previewContainer.querySelector('.preview-video');
                if (oldVideo) { oldVideo.pause(); oldVideo.src = ''; }
            }

            // Hide the per-card video mute button on delete
            if (mediaType === 'video' && previewCard) {
                const muteBtn = previewCard.querySelector('.media-mute-button');
                if (muteBtn) muteBtn.setAttribute('data-show-btn', defaultSrc ? 'true' : 'false');
            }

            if (previewContainer) {
                if (defaultSrc) {
                    if (mediaType === 'video') {
                        previewContainer.innerHTML = '' +
                            '<div class="preview-content video-preview">' +
                                `<video src="${defaultSrc}" data-key-uid="${themeUid || ''}" class="preview-video" muted loop playsinline preload="metadata"></video>` +
                                '<div class="play-overlay">' +
                                    '<i class="bi bi-play-circle-fill"></i>' +
                                '</div>' +
                            '</div>';
                    } else {
                        previewContainer.innerHTML = '' +
                            '<div class="preview-content image-preview">' +
                                `<img src="${defaultSrc}" alt="Preview" data-key-uid="${themeUid || ''}" class="preview-image">` +
                            '</div>';
                    }
                } else {
                    previewContainer.innerHTML = '' +
                        '<div class="preview-content empty-state">' +
                            (mediaType === 'video'
                                ? '<i class="bi bi-camera-video"></i><span>Click to upload video</span>'
                                : '<i class="bi bi-image"></i><span>Click to upload image</span>') +
                        '</div>';
                }
            }

            if (themeUid) {
                setMediaSrcByUid(themeUid, defaultSrc);
            }
        });
    });

    const mediaInputs = document.querySelectorAll('.media-file-input[data-theme-uid]');
    mediaInputs.forEach((inputElement) => {
        if (inputElement.dataset.boundInputHandler === 'true') return;
        inputElement.dataset.boundInputHandler = 'true';

        inputElement.addEventListener('change', () => {
            const inputId = inputElement.id;
            if (!inputId) return;

            // Capture files before any reset
            const nativeFiles = inputElement.files ? Array.from(inputElement.files) : [];

            // Find associated media-preview-card. Input may be a sibling of the card
            // (.form-group > .media-preview-card + input), not inside it.
            const cardDirect  = inputElement.closest('.media-preview-card');
            const cardSibling = !cardDirect && inputElement.parentElement
                ? inputElement.parentElement.querySelector('.media-preview-card')
                : null;
            const card     = cardDirect || cardSibling;
            const previewEl = card ? card.querySelector('.preview-container') : null;

            // For media-preview-card inputs (branding logo, cover image, etc.),
            // delegate to applyFileToInput which updates the preview + _selectedFiles.
            // Background music has its own handler (handleMusicFileUpload) so skip it here.
            if (card && previewEl && nativeFiles.length > 0 && typeof window.applyMediaFileToInput === 'function') {
                window.applyMediaFileToInput(inputElement, nativeFiles);
                return; // applyFileToInput handles delete button + data-file-action
            }

            // Fallback: update delete-button visibility for non-preview-card inputs
            const deleteButton = document.querySelector(`.media-delete-button[data-media-id="${inputId}"]`);
            if (deleteButton && nativeFiles.length > 0) {
                deleteButton.setAttribute('data-show-btn', 'true');
                inputElement.setAttribute('data-file-action', 'upload');
            }
        });
    });

    // ── Preview-container click → open media picker ──────────────────────────
    // Makes clicking anywhere on the image/video/empty-state within a media card
    // trigger the same picker as the pencil button, for a more intuitive UX.
    const previewContainers = document.querySelectorAll('.media-preview-card .preview-container');
    previewContainers.forEach((container) => {
        if (container.dataset.boundPreviewClick === 'true') return;
        container.dataset.boundPreviewClick = 'true';
        container.style.cursor = 'pointer';

        container.addEventListener('click', (event) => {
            // Don't interfere if the user clicked a button inside the overlay
            if (event.target.closest('.hover-overlay')) return;

            const card = container.closest('.media-preview-card');
            // Input may be a sibling of the card, not inside it — check parent
            const parent = card ? card.parentElement : null;
            const inputEl = (parent && parent.querySelector('.media-file-input'))
                         || (card && card.querySelector('.media-file-input'))
                         || null;
            if (!inputEl) return;

            if (typeof window.openMediaPicker === 'function') {
                window.openMediaPicker(inputEl, container);
            } else {
                inputEl.click();
            }
        });
    });

    // ── Per-card video mute buttons ──────────────────────────────────────────
    const muteButtons = document.querySelectorAll('.media-mute-button[data-media-id]');
    muteButtons.forEach((button) => {
        if (button.dataset.boundMuteHandler === 'true') return;
        button.dataset.boundMuteHandler = 'true';

        button.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();

            const previewCard = button.closest('.media-preview-card');
            if (!previewCard) return;
            const video = previewCard.querySelector('.preview-video');
            if (!video) return;

            video.muted = !video.muted;
            // If the video stopped (e.g. browser paused it), restart it
            if (video.paused) video.play().catch(() => {});
            const icon = button.querySelector('i');
            if (icon) icon.className = video.muted ? 'bi bi-volume-mute-fill' : 'bi bi-volume-up-fill';
        });
    });
}

// Extract form data only from inputs with data-theme-key attribute
function extractFormDataWithThemeKeys(form) {
    const formData = {};
    
    // Get all form elements with data-theme-key attribute
    const elementsWithThemeKey = form.querySelectorAll('[data-theme-key]');
    
    elementsWithThemeKey.forEach(element => {
        const themeKey = element.getAttribute('data-theme-key');
        
        if (!themeKey) return; // Skip if data-theme-key is empty
        
        let value = null;
        
        // Handle different input types
        if (element.type === 'checkbox') {
            value = element.checked;
        } else if (element.type === 'radio') {
            if (element.checked) {
                value = element.value;
            } else {
                return; // Skip unchecked radio buttons
            }
        } else if (element.tagName === 'SELECT') {
            if (element.multiple) {
                value = Array.from(element.selectedOptions).map(option => option.value);
            } else {
                value = element.value;
            }
        } else if (element.tagName === 'TEXTAREA') {
            value = element.value;
        } else {
            value = element.value;
        }
        
        // Handle nested keys (e.g., "invitation.rsvp.enabled" -> {invitation: {rsvp: {enabled: value}}})
        if (themeKey.includes('.')) {
            const keys = themeKey.split('.');
            let current = formData;
            
            for (let i = 0; i < keys.length - 1; i++) {
                if (!current[keys[i]]) {
                    current[keys[i]] = {};
                }
                current = current[keys[i]];
            }
            
            current[keys[keys.length - 1]] = value;
        } else {
            formData[themeKey] = value;
        }
    });
    
    return formData;
}

// Helper function to format date display
function updateDateDisplay(dateValue, prefix) {
    if (!dateValue) return;
    
    const date = new Date(dateValue);
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    
    const monthElement = document.getElementById(`${prefix}_month`);
    const dateElement = document.getElementById(`${prefix}_date`);
    const yearElement = document.getElementById(`${prefix}_year`);
    
    if (monthElement) monthElement.textContent = months[date.getMonth()];
    if (dateElement) dateElement.textContent = String(date.getDate()).padStart(2, '0');
    if (yearElement) yearElement.textContent = date.getFullYear();
}

// Helper function to format time display
function updateTimeDisplay(timeValue) {
    if (!timeValue) return;
    
    const [hours, minutes] = timeValue.split(':');
    const hour24 = parseInt(hours);
    const hour12 = hour24 % 12 || 12;
    const period = hour24 >= 12 ? 'PM' : 'AM';
    
    const timeElement = document.getElementById('event_time');
    const periodElement = document.getElementById('event_period');
    
    if (timeElement) timeElement.textContent = `${String(hour12).padStart(2, '0')}:${minutes}`;
    if (periodElement) periodElement.textContent = period;
}

// Make validity boxes clickable to trigger date picker
document.addEventListener('DOMContentLoaded', function() {
    // Initialize date displays on page load
    const dateInput = document.getElementById('event_date');
    const timeInput = document.getElementById('event_time');
    const startDateInput = document.getElementById('startDate');
    const endDateInput = document.getElementById('endDate');

    if (dateInput && dateInput.value) {
        // if body data-cp="create" and date is less than current date, set date to current date
        const bodyElement = document.querySelector('body');
        if (bodyElement && bodyElement.getAttribute('data-cp') === 'create') {
            const currentDate = new Date().toISOString().split('T')[0];
            if (dateInput.value < currentDate) {
                dateInput.value = currentDate;
            }
        }
        updateDateDisplay(dateInput.value, 'event');
    }
    if (timeInput && timeInput.value) {
        updateTimeDisplay(timeInput.value);
    }
    if (startDateInput && startDateInput.value) {
        updateDateDisplay(startDateInput.value, 'validity_from');
    }
    if (endDateInput && endDateInput.value) {
        updateDateDisplay(endDateInput.value, 'validity_to');
    }
});

// date change update the endDate value to be >= start date and set date value to endDate
var _eventDateEl = document.getElementById('event_date');
if (_eventDateEl) {
    _eventDateEl.addEventListener('change', function() {
        const eventDate = this.value;
        const endDateInput = document.getElementById('endDate');
        const startDateInput = document.getElementById('startDate');
        if (endDateInput) {
            endDateInput.value = eventDate;
            endDateInput.min = eventDate;
        }
        if (startDateInput) {
            startDateInput.max = eventDate;
            // If there is no value in startDate, set it to current date (today)
            if (!startDateInput.value) {
                startDateInput.value = new Date().toISOString().split('T')[0];
            }
            // if the body data-cp="create" and startDate is less than the current date, set startDate to current date
            const bodyElement = document.querySelector('body');
            if (bodyElement && bodyElement.getAttribute('data-cp') === 'create') {
                const currentDate = new Date().toISOString().split('T')[0];
                if (startDateInput.value < currentDate) {
                    startDateInput.value = currentDate;
                }
            }
            // Start date should not be greater than event date
            if (startDateInput.value > eventDate) {
                startDateInput.value = eventDate;
            }
        }
        // Update date displays
        updateDateDisplay(eventDate, 'event');
        if (endDateInput) updateDateDisplay(eventDate, 'validity_to');
        if (startDateInput && startDateInput.value) {
            updateDateDisplay(startDateInput.value, 'validity_from');
        }
    });
}

// On time change, update the time display
var _eventTimeEl = document.getElementById('event_time');
if (_eventTimeEl) {
    _eventTimeEl.addEventListener('change', function() {
        updateTimeDisplay(this.value);
    });
}

// On startDate change, update the validity display and inviteDays
var _startDateEl = document.getElementById('startDate');
if (_startDateEl) {
    _startDateEl.addEventListener('change', function() {
        updateDateDisplay(this.value, 'validity_from');
    });
}

// On endDate change, update the validity display and inviteDays
var _endDateEl = document.getElementById('endDate');
if (_endDateEl) {
    _endDateEl.addEventListener('change', function() {
        updateDateDisplay(this.value, 'validity_to');
    });
}

// Update offer carousel based on day count
function updateOfferCarousel(dayDiff) {
    const carousel = document.getElementById('offersCarousel');
    if (!carousel) return;
    
    // Get Bootstrap carousel instance
    const bsCarousel = bootstrap.Carousel.getInstance(carousel) || new bootstrap.Carousel(carousel, {
        interval: false, // Disable auto-sliding
        wrap: false
    });
    
    // Determine which slide to show based on days
    let targetSlide = 1; // Default to 10% offer (slide 1)
    
    if (dayDiff > 30) {
        targetSlide = 0; // Show 25% offer (slide 0)
    } else if (dayDiff > 15) {
        targetSlide = 1; // Show 10% offer (slide 1)
    }
    
    // Get current active slide index
    const activeItem = carousel.querySelector('.carousel-item.active');
    const allItems = Array.from(carousel.querySelectorAll('.carousel-item'));
    const currentSlide = allItems.indexOf(activeItem);
    
    // Only animate if we're changing slides
    if (currentSlide !== targetSlide) {
        // Animate carousel fade out
        gsap.to(carousel, {
            opacity: 0,
            y: -10,
            duration: 0.25,
            ease: "power1.out",
            onComplete: () => {
                // Change slide
                bsCarousel.to(targetSlide);
                
                // Animate carousel fade in
                gsap.fromTo(carousel, 
                    { opacity: 0, y: 30 },
                    { 
                        opacity: 1, 
                        y: 0, 
                        duration: 0.6,
                        ease: "power3.out",
                        onComplete: () => {
                            gsap.set(carousel, { clearProps: "opacity,y,transform,x,scale" });
                        }
                    }
                );
            }
        });
    }
}